




























import { Component, Vue, Emit, Inject } from 'vue-property-decorator'
import { uid, skey, toLogin, getSelectedCityId } from '@utils/index'
import { ensureLogin } from '@utils/decorators'
import SmallItem from './smallItem.vue'
import SmallItem2 from './smallItem2.vue'
import All from './all.vue'
import Deliver from '../deliver.vue'
import { ShopTypes } from '../../config'
import { Overlay, Toast } from 'vant'
import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')

@Component({
  components: {
    SmallItem,
    SmallItem2,
    All,
    Deliver,
    [Overlay.name]: Overlay,
  },
})
export default class Coupon extends Vue {
  @Inject({ default: null })
  viewCouponTrackParams!: any
  
  readonly Children: ShopTypes = ShopTypes.Children
  couponAllShow: boolean = false

  @shopHomeModule.State shopType!: ShopTypes
  @shopHomeModule.State couponDetail!: any
  @shopHomeModule.Action getCouponAction!: (par: { shopId: string | number }) => Promise<any>
  @shopHomeModule.Action sendCouponAction!: (par: any) => Promise<any>

  get smallItem() {
    return this.shopType === this.Children ? SmallItem2 : SmallItem
  }

  get couponData() {
    let couponData: any[] = (this.couponDetail && this.couponDetail.couponList) || []
    // 作废、过期不展示，领取开始时间未到不展示，按面额大小排序，从大到小
    couponData = couponData.filter((c) => c.isShow && c.status != 3 && c.getStartTime < Date.now() && c.getEndTime > Date.now())
    couponData.sort((c1, c2) => {
      return c2.couponAmount - c1.couponAmount
    })
    return couponData
  }

  @ensureLogin(true, true)
  async receiveCoupon(coupon: any) {
    const param = {
      couponCode: coupon.couponCode,
      couponId: coupon.couponId,
      uid,
      skey,
    }
    const res = await this.sendCouponAction(param)
    if (res.code == 1) {
      Toast(res.msg || '领取成功')
      this.getCoupon()
    } else if (res.code == 4) {
      toLogin()
    } else {
      console.log(res)
      Toast(res.msg)
    }
  }

  async created() {}

  showAllCoupon() {
    this.couponAllShow = true
    this.viewCouponTrackParams && this.$newClickTracker(this.viewCouponTrackParams)
  }

  @Emit()
  getCoupon() {}
}
